/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddSubstanceInputRowRequest } from "../models/AddSubstanceInputRowRequest";
import type { Body_Formulation_create_new_input } from "../models/Body_Formulation_create_new_input";
import type { BooleanResponse } from "../models/BooleanResponse";
import type { Response_SubstanceInput_ } from "../models/Response_SubstanceInput_";
import type { Response_UUID_ } from "../models/Response_UUID_";
import type { UpdateSubstanceInputRequest } from "../models/UpdateSubstanceInputRequest";
import type { UpdateSubstanceInputRowsRequest } from "../models/UpdateSubstanceInputRowsRequest";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class FormulationService {
  /**
   * Create New Input
   * @param formData
   * @returns Response_UUID_ Successful Response
   * @throws ApiError
   */
  public static formulationCreateNewInput(
    formData: Body_Formulation_create_new_input
  ): CancelablePromise<Response_UUID_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/formulation/inputs",
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Substance Input
   * @param substanceInputId
   * @returns Response_SubstanceInput_ Successful Response
   * @throws ApiError
   */
  public static formulationGetSubstanceInput(
    substanceInputId: string
  ): CancelablePromise<Response_SubstanceInput_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/formulation/inputs/{substance_input_id}",
      path: {
        substance_input_id: substanceInputId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Substance Input
   * @param substanceInputId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static formulationUpdateSubstanceInput(
    substanceInputId: string,
    requestBody: UpdateSubstanceInputRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/formulation/inputs/{substance_input_id}",
      path: {
        substance_input_id: substanceInputId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Substance Input Row
   * @param substanceInputId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static formulationAddSubstanceInputRow(
    substanceInputId: string,
    requestBody: AddSubstanceInputRowRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/formulation/inputs/{substance_input_id}/rows",
      path: {
        substance_input_id: substanceInputId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Bulk Update Substance Input Rows
   * @param substanceInputId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static formulationBulkUpdateSubstanceInputRows(
    substanceInputId: string,
    requestBody: UpdateSubstanceInputRowsRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/formulation/inputs/{substance_input_id}/rows",
      path: {
        substance_input_id: substanceInputId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Substance Input Row
   * @param substanceInputId
   * @param substanceInputRowId
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static formulationDeleteSubstanceInputRow(
    substanceInputId: string,
    substanceInputRowId: string
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/formulation/inputs/{substance_input_id}/rows/{substance_input_row_id}",
      path: {
        substance_input_id: substanceInputId,
        substance_input_row_id: substanceInputRowId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
